<template lang="pug">

    div

        div(v-for='(address, index) in addresses')

            h3.ui.block.header
                span {{ (index+1) + ". Lieferadresse" }}
                span.shipping-address-remove-icon(
                    v-on:click='remove(address)'
                    v-show='addresses.length > 1'
                )
                    i.remove.icon

            .field
                address-form(
                    ref="addressForms"
                    v-bind:address-models='shippingAddresses'
                    v-bind:company-model='companyModel'
                    v-bind:country-models='countryModels'
                    v-bind:enable-preselection='index === 0'
                    v-bind:person-models='personModels'
                    v-bind:value='address'
                    v-on:input='update($event, index)'
                )

            .ui.divider(v-show='addresses.length > 1 && (index+1) < addresses.length')

        .field
            .ui.grid
                .right.aligned.column
                    a.ui.right.labeled.icon.button(v-on:click="add()")
                        i.plus.icon
                        | Adresse hinzfügen


</template>

<script>
    import DateField from '@/components/form/DateField.vue'
    import DropdownField from '@/components/form/DropdownField.vue'
    import Error from '@/components/form/FieldError.vue'
    import AddressForm from './shipping-addresses-form/AddressForm.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { AddressForm, DateField, DropdownField, Error },

        computed: {
            $invalid() {
                return this.$refs.addressForms.find(form => form.$invalid) !== undefined
            },
            addresses() {
                return [...this.value]
            }
        },

        methods: {
            $touch() {
                this.$refs.addressForms.forEach(form => form.$touch())
            },
            add() {
                const addresses = [...this.value]
                addresses.push({})
                this.$emit('input', addresses)
            },
            remove(addressToRemove) {
                const addresses = this.value.filter(address => address !== addressToRemove)
                this.$emit('input', addresses)
            },
            update(value, index) {
                const addresses = [...this.value]
                addresses[index] = value
                this.$emit('input', addresses)
            }
        },

        props: {
            companyModel: {
                type: Object,
                required: true
            },
            countryModels: {
                type: Array,
                required: true,
            },
            personModels: {
                type: Array,
                required: true
            },
            shippingAddresses: {
                type: Array,
                required: true
            },
            value: {
                type: Array,
                required: true
            }
        },

    }

</script>

<!--suppress CssUnusedSymbol -->
<style>

    .shipping-address-remove-icon {
        cursor: pointer;
        float: right
    }

</style>
